import pic8 from "../Images/8.jpg";

const CardData = [
  {
    imgsrc: pic8,
    title: "Web development",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic8,
    title: "App development",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic8,
    title: "Software development",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic8,
    title: "Content Writing",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic8,
    title: "Fashion design",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic8,
    title: "Entrepreneur",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
];
export default CardData;
